/* global axios */
import ApiClient from './ApiClient';

class ComplianceReportsAPI extends ApiClient {
  constructor() {
    super('compliance_reports', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  download() {
    return axios.get(`${this.url}/download`, {
      responseType: 'blob',
    });
  }

  downloadHistory() {
    return axios.get(`${this.url}/download_history`, {
      responseType: 'blob',
    });
  }
}

export default new ComplianceReportsAPI();
